import { Grid } from '@mui/material';
import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { quickInputSelector } from '../QuickInput/reducers/QuickInputReducer';
import './Agent.scss';
import AgentInput from './AgentInput';
import AgentSearch from './AgentSearch';
import AgentTable from './AgentTable';
import { setTriggerRefreshInput, setTriggerSave } from './reducers/AgentInputReducer';
import { resetAgentSearch, setTriggerAgentSearch } from '../Agent/reducers/AgentSearchReducer';
import CargoTypeSelectorApi from '../CargoTypeSelector/api/CargoTypeSelectorApi';
import BaseResponse from '../../app/BaseResponse';
import CargoTypeModel from '../CargoTypeSelector/models/CargoTypeModel';
import { setCargoTypesCache } from '../CargoTypeManagement/reducers/CargoTypeManagementReducer';
import Utility from '../../app/utility';
import { showLoading } from '../LoadingView/reducers/LoadingViewReducer';
import { setCargoGroups, setCargoTypes } from '../CargoTypeSelector/reducers/CargoTypeSelectorReducer';
import _ from 'lodash';

let triggerHotkeyAlready = false;

const Agent: React.FunctionComponent = () => {
    const dispatch = useDispatch();
    const quickInputData = useSelector(quickInputSelector);

    useEffect(() => {
        document.title = "Agent";

        // attach the event listener
        document.addEventListener('keydown', handleKeyPress);

        loadCargoTypes();
    }, []);

    const loadCargoTypes = () => {
            dispatch(showLoading(true));

            CargoTypeSelectorApi.GetCargoTypes()
            .then((response: BaseResponse<CargoTypeModel[]>) => {
                if (response.success) {
                    _.each(response.data, (type) =>{
                        type.positive = true;
                    })

                    dispatch(setCargoTypes(response.data));
                } else {
                    Utility.Alert.Error(response.message);
                }
            })
            .catch((error) => {
                Utility.Alert.Error(error);
            }).finally(() => {
                dispatch(showLoading(false));
            })
    }

    const handleKeyPress = useCallback((event) => {
        if (!triggerHotkeyAlready) {
            if (event.altKey) {
                switch (event.key) {
                    case "s":
                        //save
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerSave((new Date()).getTime()));
                        break;
                    case "r":
                        //refresh save
                        dispatch(setTriggerRefreshInput((new Date()).getTime()));
                        break;
                    case "w":
                        //search
                        triggerHotkeyAlready = true;
                        dispatch(setTriggerAgentSearch((new Date()).getTime()));
                        break;
                    case "q":
                        //refresh search
                        dispatch(resetAgentSearch());
                        break;
                    default:
                        break;
                }
            }

            setTimeout(() => {
                triggerHotkeyAlready = false;
            }, 2000);
        }
    }, []);

    return (
        <>
            <Grid container className="tonnage">
                <Grid item lg={2} xs={12} className="left-search-area">
                    <AgentSearch></AgentSearch>
                </Grid>
                <Grid item lg={10} xs={12} className="right-content">
                    <Grid container className="input-fields">
                        <div className={quickInputData.showQuickInput ? "tonnage-quick-input-collapse" : "tonnage-quick-input-expand"}>
                            <AgentInput></AgentInput>
                        </div>
                    </Grid>
                    <Grid container className="datatable">
                        <AgentTable>
                        </AgentTable>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
};

export default Agent;